import { NodeSingular } from 'cytoscape';

import { SynopticNodeData } from '@connect-services/client/components/synoptic/synoptic-graph/graph-core/synoptic-graph.model';
import { ColorEnum } from '@connect-services/client/components/synoptic/synoptic-plan/plan-core/synoptic-plan.constants';
import {
    CableDirectionEnum,
    DrawerReference,
    SynopticBayPlanItem,
    SynopticBoxPlanCableBySide,
    SynopticBoxPlanItem,
} from '@connect-services/src/sdk/api';

export type Cables = Record<string, CableConnections>;
export type CableConnections = { entrant: Record<string, Cable>; sortant: Record<string, Cable> };

export type Cable = {
    boiteBaie?: string | null;
    boiteBaieCodeext: string | null;
    boiteBaieEtiquet: string | null;
    codeext?: string | null;
    etiquet?: string | null;
    tubes: Record<string, Tube>;
};

export type Tube = { color: ColorEnum; typeFibre: string };

export type Cassettes<T extends SynopticPlanItem> = Record<string, T[]>;

export type BayDrawer = {
    cables: SynopticBoxPlanCableBySide;
    cassettes: SynopticBayPlanItem[][];
    code: string | null;
    id: string | null;
    length: number;
    position: string | null;
    reference: string | null;
    side: string | null;
};

export type Drawer = {
    cassettes: Cassettes<SynopticBayPlanItem>;
    position?: string | null;
    taille?: string | null;
};

export type Drawers = Record<string, Drawer>;

export type SelectedNode = { dataNode: SynopticNodeData; rawNode: NodeSingular };

export type SynopticPlanItem = SynopticBoxPlanItem | SynopticBayPlanItem;

type LinkToDeleteBase = {
    cable?: string | null;
    cassetteKey: string;
    side: CableDirectionEnum;
    type: LinkTypeEnum;
};
export type FiberLink = LinkToDeleteBase & { fiber?: string | null; type: LinkTypeEnum.FIBER };
export type TubeLink = LinkToDeleteBase & { tube: number; type: LinkTypeEnum.TUBE };
export type LinkToDelete = FiberLink | TubeLink;

export interface SynopticFilterOption {
    drawer?: string;
    key: string;
    numero: number;
    text: string;
}

export enum FiberingSideEnum {
    ALL = 'all',
    ENTERING = 'entering',
    OUTGOING = 'outgoing',
    SELECTION = 'selection',
}

export enum RestoreActionEnum {
    CANCEL = 'cancel',
    RESTORE = 'restore',
}

export enum CableActionEnum {
    DOWN = 'down',
    UP = 'up',
}
export type CableAction = { action: CableActionEnum; code: string };

export enum PositionEnum {
    ENTRANT = 'entrant',
    SORTANT = 'sortant',
}

export enum LinkTypeEnum {
    FIBER = 'fiber',
    TUBE = 'tube',
}

export class Cassette {
    public decomposedCassette!: SynopticBoxPlanItem[];
    public key!: string;
    public parent!: HTMLElement;
    public target!: HTMLElement;
    public constructor(
        decomposedCassette: SynopticBoxPlanItem[],
        key: string,
        parent: HTMLElement,
        target: HTMLElement,
    ) {
        this.decomposedCassette = decomposedCassette;
        this.key = key;
        this.parent = parent;
        this.target = target;
    }
}

export type DrawerReferenceData = Omit<DrawerReference, 'cassettesReferences' | 'referenceName'> & {
    position: number;
    side: SynopticBayPlanItem.CoteTiroirEnum;
};
